<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.budget__section_1')}}</h4>
            <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.budget__section_1_sub')}}</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                        <div class="col-lg-6">
                          NOT APPLICABLE
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_proposal')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.proposal_number"
                                 value="true"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.proposal_number"
                                 value="false"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.proposal_number"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_period_implementation')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.period_implementation"
                                 value="true"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.period_implementation"
                                 value="false"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.period_implementation"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_choice_between')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.choice_between"
                                 value="true"
                                 v-model="EvaluationForm.model.choice_between"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.choice_between"
                                 value="false"
                                 v-model="EvaluationForm.model.choice_between"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.choice_between"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.choice_between"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_follow_templates')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.follow_templates"
                                 value="true"
                                 v-model="EvaluationForm.model.follow_templates"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.follow_templates"
                                 value="false"
                                 v-model="EvaluationForm.model.follow_templates"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.follow_templates"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.follow_templates"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_has_tab')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.has_tab"
                                 value="true"
                                 v-model="EvaluationForm.model.has_tab"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.has_tab"
                                 value="false"
                                 v-model="EvaluationForm.model.has_tab"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.has_tab"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.has_tab"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_is_forecast')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.is_forecast"
                                 value="true"
                                 v-model="EvaluationForm.model.is_forecast"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.is_forecast"
                                 value="false"
                                 v-model="EvaluationForm.model.is_forecast"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.is_forecast"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.is_forecast"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__1_amount_match')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.amount_match"
                                 value="true"
                                 v-model="EvaluationForm.model.amount_match"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.amount_match"
                                 value="false"
                                 v-model="EvaluationForm.model.amount_match"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.amount_match"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.amount_match"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('medium_grant_ev.budget__comment_missing_doc')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_missing_doc" :comments="EvaluationForm.model.comments_budget_missing_doc"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('medium_grant_ev.budget__section_2')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                        <div class="col-lg-6">
                          NOT APPLICABLE
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_2_1')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.lines_calculated"
                                 value="true"
                                 v-model="EvaluationForm.model.lines_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.lines_calculated"
                                 value="false"
                                 v-model="EvaluationForm.model.lines_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.lines_calculated"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.lines_calculated"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_2_2')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.subtotals_calculated"
                                 value="true"
                                 v-model="EvaluationForm.model.subtotals_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.subtotals_calculated"
                                 value="false"
                                 v-model="EvaluationForm.model.subtotals_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.subtotals_calculated"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.subtotals_calculated"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_2_3')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.indirect_cost_calculated"
                                 value="true"
                                 v-model="EvaluationForm.model.indirect_cost_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.indirect_cost_calculated"
                                 value="false"
                                 v-model="EvaluationForm.model.indirect_cost_calculated"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.indirect_cost_calculated"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.indirect_cost_calculated"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_2_4')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.formulae_used"
                                 value="true"
                                 v-model="EvaluationForm.model.formulae_used"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.formulae_used"
                                 value="false"
                                 v-model="EvaluationForm.model.formulae_used"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.formulae_used"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.formulae_used"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('medium_grant_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_mathematical" :comments="EvaluationForm.model.comments_budget_mathematical"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('medium_grant_ev.budget__section_3')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                        <div class="col-lg-6">
                          NOT APPLIACBLE
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_1')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.costs_aligned"
                                 value="true"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.costs_aligned"
                                 value="false"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.costs_aligned"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_2')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.clearance_ineligible"
                                 value="true"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.clearance_ineligible"
                                 value="false"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearance_ineligible"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_3')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.cost_categories"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.cost_categories"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_categories"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_4')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.diferent_partners"
                                 value="true"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.diferent_partners"
                                 value="false"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.diferent_partners"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_5')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.clearly_desc_cost"
                                 value="true"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.clearly_desc_cost"
                                 value="false"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearly_desc_cost"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_6')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.inaproppiate_cost"
                                 value="true"
                                 v-model="EvaluationForm.model.inaproppiate_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.inaproppiate_cost"
                                 value="false"
                                 v-model="EvaluationForm.model.inaproppiate_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.inaproppiate_cost"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.inaproppiate_cost"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_7')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.cost_breakdown"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_breakdown"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.cost_breakdown"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_breakdown"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_breakdown"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.cost_breakdown"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_3_8')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.cost_further_explained"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_further_explained"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.cost_further_explained"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_further_explained"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_further_explained"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.cost_further_explained"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('medium_grant_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_eligibility" :comments="EvaluationForm.model.comments_budget_eligibility"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('medium_grant_ev.budget__section_4')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                        <div class="col-lg-6">
                          NOT APPLICABLE
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_1')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.personel_costs_corectly"
                                 value="true"
                                 v-model="EvaluationForm.model.personel_costs_corectly"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.personel_costs_corectly"
                                 value="false"
                                 v-model="EvaluationForm.model.personel_costs_corectly"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.personel_costs_corectly"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.personel_costs_corectly"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_2')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.personel_costs_inclussive"
                                 value="true"
                                 v-model="EvaluationForm.model.personel_costs_inclussive"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.personel_costs_inclussive"
                                 value="false"
                                 v-model="EvaluationForm.model.personel_costs_inclussive"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.personel_costs_inclussive"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.personel_costs_inclussive"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_3')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.devco_rates"
                                 value="true"
                                 v-model="EvaluationForm.model.devco_rates"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.devco_rates"
                                 value="false"
                                 v-model="EvaluationForm.model.devco_rates"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.devco_rates"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.devco_rates"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_4')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.equipment_costs"
                                 value="true"
                                 v-model="EvaluationForm.model.equipment_costs"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.equipment_costs"
                                 value="false"
                                 v-model="EvaluationForm.model.equipment_costs"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.equipment_costs"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.equipment_costs"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_5')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.duplicate_direct_cost"
                                 value="true"
                                 v-model="EvaluationForm.model.duplicate_direct_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.duplicate_direct_cost"
                                 value="false"
                                 v-model="EvaluationForm.model.duplicate_direct_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.duplicate_direct_cost"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.duplicate_direct_cost"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_6')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.cost_sufficient_detailed"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_sufficient_detailed"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.cost_sufficient_detailed"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_sufficient_detailed"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_sufficient_detailed"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.cost_sufficient_detailed"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_4_7')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.cost_expediture"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_expediture"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.cost_expediture"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_expediture"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_expediture"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.cost_expediture"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('medium_grant_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_completness" :comments="EvaluationForm.model.comments_budget_completness"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('medium_grant_ev.budget__section_5')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-3">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                        <div class="col-lg-6">
                          NOT APPLICABLE
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_5_1')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.sco_costs"
                                 value="true"
                                 v-model="EvaluationForm.model.sco_costs"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.sco_costs"
                                 value="false"
                                 v-model="EvaluationForm.model.sco_costs"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.sco_costs"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.sco_costs"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_5_2')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.sco_costs_following"
                                 value="true"
                                 v-model="EvaluationForm.model.sco_costs_following"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.sco_costs_following"
                                 value="false"
                                 v-model="EvaluationForm.model.sco_costs_following"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.sco_costs_following"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.sco_costs_following"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('medium_grant_ev.budget__section_5_3')}}
                    </div>
                    <div class="col-lg-4 ">
                      <div class="row">
                        <div class="col-lg-3">
                          <radio name="model.sco_costs_used"
                                 value="true"
                                 v-model="EvaluationForm.model.sco_costs_used"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-3">
                          <radio name="model.sco_costs_used"
                                 value="false"
                                 v-model="EvaluationForm.model.sco_costs_used"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.sco_costs_used"
                                 value="notapplicable"
                                 v-model="EvaluationForm.model.sco_costs_used"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('medium_grant_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_sco" :comments="EvaluationForm.model.comments_sco"></comment-box>
            </div>
          </div>
        </div>


      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>